// extracted by mini-css-extract-plugin
module.exports = {"userSelectNone":"TableComponentFiltro_userSelectNone__YN8If","handCursor":"TableComponentFiltro_handCursor__1dNAE"};